// extracted by mini-css-extract-plugin
export var deliveryRow = "_ol-a";
export var fixedHeight = "_ol-4";
export var freightLogo = "_ol-9";
export var fullWidth = "_ol-3";
export var priceColumn = "_ol-5";
export var radioSelected = "_ol-7";
export var radioUnselected = "_ol-6";
export var selectedOption = "_ol-2";
export var selectedOptionContainer = "_ol-1";
export var selection = "_ol-0";
export var tallSkeletonText = "_ol-8";